<div class="row-cus" *ngIf="!isOnlineDesignPage">
    <div class="col-md-{{spaceFromRight}}"></div>
        <div class="col-md-{{width}} page-title-col" [ngClass]="{'isOnlineDesignPage': isOnlineDesignPage}">
                <div class="row">
                                <div class="col-12">
                                                <div class="page-title">{{title}}</div>
                                                <div class="phone-num" *ngIf="displayPhone"><a href="tel://050-968-8307">050-968-8307</a> <fa-icon [icon]="['fas', 'phone-square']" ></fa-icon></div>
                                                
                                </div>
                                
                                
                </div>
                
        </div>
        
</div>

<div class="row-cus" *ngIf="isOnlineDesignPage">
                <div class="col-md-12"></div>
                    <div class="col-md-12 page-title-col" [ngClass]="{'isOnlineDesignPage': isOnlineDesignPage}">
                            <div class="row">
                                            <div class="col-12">
                                                            <div class="page-title">{{title}}</div>
                                                            <div class="phone-num" *ngIf="displayPhone"><a href="tel://050-968-8307">050-968-8307</a> 
                                                                <fa-icon [icon]="['fas', 'phone-square']" ></fa-icon>
                                                            <div class="coupon-div" *ngIf="isOnlineDesignPage && displayCoupon">
                     
                                                                   <app-coupon-btn></app-coupon-btn>
                                                            </div>
                                            </div>
                                            
                                            
                            </div>
                            
                    </div>
                    
            </div>


